import React, { FC, useMemo } from 'react'
import { AsH2, Text } from '@/atoms/Text'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { SoldOutInfoIconTooltip } from '@/views/TicketCheckoutViews/ShowtimesView/components/SoldOutInfoIconTooltip'

interface Props {
  soldOut: number
}
const VenuesSoldOutAlert: FC<Props> = ({ soldOut }) => {
  const { t } = useTranslate('tickets')

  const alertText = useMemo(() => {
    return (
      <Translate i18nKey="soldOutShowtimesNationwide" t={t} values={{ soldOut }}>
        <span className="photon-caption-xl font-semibold">{{ soldOut }}</span> sold out theaters nationwide. Selling
        Fast! <SoldOutInfoIconTooltip />
      </Translate>
    )
  }, [soldOut, t])

  return (
    <div className="inline-block rounded-lg border-l-4 border-error-300 bg-error-100 px-2 py-3" role="alert">
      <Text as={AsH2} className="photon-caption-md md:photon-caption-lg">
        {alertText}
      </Text>
    </div>
  )
}

export default VenuesSoldOutAlert
